import { bigBrain } from '@mondaydotcomorg/bigbrain/BigBrainWeb';
import { useCallback, useEffect, useState } from 'react';
import { useMondayContext } from '../contexts/monday-context';
import { bigBrainEvents } from '../constants';

const appName = 'crm_service';
const placement = 'billing_app';
const bigBrainService = bigBrain(process.env.NODE_ENV, appName);

export default function useBigbrain() {
  const { userData = {} } = useMondayContext();
  const { id: userId, accountId } = userData;
  const [hasBBLoaded, setHasBBLoaded] = useState(false);

  const bigBrainTrack = useCallback(
    (name, data = {}) => {
      if (!userId || !accountId) return null;

      bigBrainService.track(name, {
        ...data,
        pulse_user_id: userId,
        pulse_account_id: accountId,
        placement,
      });
    },
    [userId, accountId]
  );

  useEffect(() => {
    if (!bigBrainTrack) return;

    window.bigBrainTrack = bigBrainTrack;
    setHasBBLoaded(true);
  }, [bigBrainTrack]);

  return { bigBrainTrack, bigBrainEvents, hasBBLoaded };
}
